import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  SpuOfferListQuery,
  SpuOfferListVo,
  QueryAttr,
  CommonAreaAndAttrInfoVo,
  selectedCondition,
  // SpecifyNonData,
  PriceRangeVo
} from './type';

/**
 * 在spu页面根据spuId查询
  账号、陪玩、代练、装备：查询offer
  GET /product/urlMapping/game-service/getOtherBusinessSpuInfoShowVo
  接口ID：257336685
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336685
 */
export const getSpuOfferList = (params: SpuOfferListQuery): AxiosPromise<SpuOfferListVo> => {
  return request({
    url: '/product/urlMapping/game-service/getOtherBusinessSpuInfoShowVo',
    method: 'get',
    params
  });
};

/**
 * 金币 账号 代练 装备，这4个业务spu offer页面查询平台 区域 服务器 + 属性数据
 */
export const getAreaAndAttrInfo = (params: QueryAttr): AxiosPromise<CommonAreaAndAttrInfoVo[]> => {
  return request({
    url: '/product/product-common/getAreaAndAttrInfo',
    method: 'get',
    params
  });
};

/**
 * 非独立入口的属性值路由跳转后获取其指定数据
 */
// export const getSpecifyNonData = (params: { spuAttrId?: string | number }): AxiosPromise<SpecifyNonData> => {
//   return request({
//     url: '/product/product-common/getSpecifyNonData',
//     method: 'get',
//     params
//   });
// };

/**
 * 非路由跳转后获取其指定数据 【templateType === spu-offer-filter】
 */
// export const getConditionData = (params: { filterId?: string | number }): AxiosPromise<Condition[]> => {
//   return request({
//     url: '/product/urlMapping/game-service/getCondition',
//     method: 'get',
//     params
//   });
// };

/**
 * 根据条件获取平台 区域 服务器 + 属性数据 Game Service templateType === spu-offer-filter】
 */
export const getAreaAndAttrInfoByConditions = (params: {
  filterId?: string | number;
}): AxiosPromise<CommonAreaAndAttrInfoVo[]> => {
  return request({
    url: '/product/product-common/getAreaAndAttrInfoByConditions',
    method: 'get',
    params
  });
};

/**
 * 根据条件获取选中平台 区域 服务器 + 属性数据 Game Service templateType === spu-offer-filter】
 */
export const getSelectedConditions = (params: { filterId?: string | number }): AxiosPromise<selectedCondition[]> => {
  return request({
    url: '/product/product-common/getSelectedConditions',
    method: 'get',
    params
  });
};

/**
 * 价格排序条件 Game Service
 */
export const getPriceRange = (): AxiosPromise<PriceRangeVo[]> => {
  return request({
    url: '/product/urlMapping/game-service/getPriceRange',
    method: 'get'
  });
};
